import type { EditorState } from 'prosemirror-state';
import { Plugin, PluginKey } from 'prosemirror-state';

import type { RtPMPlugin } from '../../editor/types';

type State = { focused: boolean };
const key = new PluginKey<State>('focus');

export class FocusPlugin implements RtPMPlugin {
  public static getState(state: EditorState): State | null | undefined {
    return key.getState(state);
  }

  private plugin = new Plugin({
    key,
    state: {
      init: () => ({ focused: false }),
      apply: (tr, prevState) => {
        const value = tr.getMeta(this.plugin);
        return typeof value === 'boolean' ? { focused: value } : prevState;
      },
    },
    props: {
      handleDOMEvents: {
        focus: view => {
          view.dispatch(view.state.tr.setMeta(this.plugin, true));
          return false;
        },
        blur: view => {
          view.dispatch(view.state.tr.setMeta(this.plugin, false));
          return false;
        },
      },
    },
  });

  public getNativeEditorPlugins() {
    return [this.plugin];
  }
}
